import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles, categories, siteConfig } from '@/mocks/navigation';

export default function Articles() {
  const articlesSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `导航指南 - ${siteConfig.name}`,
    description: `夜间出行相关知识、技巧与指南 - ${siteConfig.name}`,
    url: `${siteConfig.url}/articles`,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`导航指南 | ${siteConfig.name}`}
        description={`夜间出行相关知识、技巧与指南。涵盖夜间驾车、户外探险、城市夜行等全方位夜间导航攻略 - ${siteConfig.name}`}
        keywords="夜间导航指南,夜间出行攻略,夜间驾车技巧,户外探险指南,城市夜行攻略"
        canonicalUrl={`${siteConfig.url}/articles`}
        schema={articlesSchema}
      />

      <div className="min-h-screen bg-background-50 text-foreground-500">
        <Navbar />

        <main className="pt-20">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '导航指南' },
              ]}
            />

            <div className="py-10 md:py-16">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                夜间出行<span className="text-primary-500">指南</span>
              </h1>
              <p className="text-foreground-400 text-sm md:text-base max-w-xl">
                实用的夜间出行知识、技巧与攻略，助你在黑暗中安全前行
              </p>
            </div>

            <section className="pb-20">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group bg-background-100 border border-background-200/50 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-500/20 cursor-pointer"
                  >
                    <div className="h-44 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="bg-accent-500/10 text-accent-600 text-xs font-medium px-2.5 py-1 rounded-full">
                          {article.categoryName}
                        </span>
                        <span className="text-foreground-400 text-xs">{article.date}</span>
                      </div>
                      <h3 className="text-foreground-800 font-semibold text-sm md:text-base mb-2.5 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-foreground-400 text-xs leading-relaxed line-clamp-2 mb-3">
                        {article.excerpt}
                      </p>
                      <span className="text-foreground-400 text-xs">{article.readTime}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}